const ITEMS = [
  "PROPRIETARY MINERAL MATRIX",
  "TARGETED METHYLXANTHINE BINDING",
  "MADISON, WISCONSIN USA",
  "B2B FORMULATION SUPPLY",
  "PATENT-PENDING & TRADE SECRET PROTECTED",
  "SOLE-SOURCE RELIABILITY",
  "NON-SYSTEMIC · ACTS WITHIN THE GI TRACT",
];

export const Marquee = () => {
  const row = ITEMS.map((t, i) => (
    <span key={i} className="inline-flex items-center shrink-0">
      <span className="px-6">{t}</span>
      <span className="w-1 h-1 rounded-full bg-pine/60" aria-hidden="true" />
    </span>
  ));
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-line bg-white py-4 select-none"
      aria-hidden="true"
    >
      <div className="animate-marquee flex whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.22em] text-smoke">
        <div className="flex shrink-0">{row}</div>
        <div className="flex shrink-0">{row}</div>
      </div>
    </div>
  );
};
